import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination, EffectFade } from 'swiper/modules';
import { Link } from 'react-router-dom';
import { images } from '../../assets/images';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

const Hero = () => {
  const slides = [
    {
      id: 1,
      image: images.hero[0],
      title: "Advanced Manufacturing Excellence",
      subtitle: "State-of-the-art facilities delivering precision electrical components.",
      cta: "Explore Products",
      link: "/products"
    },
    {
      id: 2,
      image: images.hero[1],
      title: "Quality You Can Trust",
      subtitle: "ISO certified production ensuring reliability in every component.",
      cta: "About Us",
      link: "/about"
    },
    {
      id: 3,
      image: images.hero[2],
      title: "Innovative Power Solutions",
      subtitle: "Empowering industries with next-generation electrical technology.",
      cta: "Contact Us",
      link: "/contact"
    }
  ];

  return (
    <section className="relative h-[600px] md:h-[700px] w-full bg-slate-900">
      <Swiper
        modules={[Autoplay, Navigation, Pagination, EffectFade]}
        effect="fade"
        spaceBetween={0}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        className="h-full w-full"
      >
        {slides.map((slide) => (
          <SwiperSlide key={slide.id}>
            <div className="relative h-full w-full">
              {/* Background Image */}
              <div 
                className="absolute inset-0 bg-cover bg-center"
                style={{ backgroundImage: `url(${slide.image})` }}
              >
                {/* Overlay */}
                <div className="absolute inset-0 bg-slate-900/60"></div>
              </div>

              {/* Content */}
              <div className="relative h-full container mx-auto px-4 flex flex-col justify-center items-start text-white">
                <div className="max-w-3xl animate-fade-in-up">
                  <h2 className="text-orange-500 font-bold text-lg md:text-xl mb-4 tracking-wider uppercase">
                    ElectroMfg Corp
                  </h2>
                  <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
                    {slide.title}
                  </h1>
                  <p className="text-lg md:text-xl text-slate-200 mb-8 max-w-2xl">
                    {slide.subtitle}
                  </p>
                  <div className="flex flex-col sm:flex-row gap-4">
                    <Link 
                      to={slide.link}
                      className="bg-orange-600 hover:bg-orange-700 text-white px-8 py-4 rounded font-bold transition-colors text-center"
                    >
                      {slide.cta}
                    </Link>
                    <Link 
                      to="/contact"
                      className="bg-transparent border-2 border-white hover:bg-white hover:text-slate-900 text-white px-8 py-4 rounded font-bold transition-colors text-center"
                    >
                      Get a Quote
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default Hero;
